import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import addmangerApi from '../../services/Api/addManager'; // adjust path if needed

// Async thunk using your custom API wrapper
export const addManager = createAsyncThunk(
  'manager/addManager',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await addmangerApi.addmanger(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const deactivateManager = createAsyncThunk(
  'manager/deactivateManager',
  async (payloadId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await addmangerApi.deactivateManager(payloadId, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
)

export const getHistoryData = createAsyncThunk(
  'manager/getHistoryData',
  async (_, { rejectWithValue }) => {
    try {
      const response = await addmangerApi.getHistory();
      return response.data.allocated_assessment_history;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);
export const getManagerList = createAsyncThunk(
  'manager/getmanagerList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await addmangerApi.getManagerList();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const updateManager = createAsyncThunk(
  'manager/updateManager',
  async (payload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await addmangerApi.updateManager(payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

const managerSlice = createSlice({
  name: 'manager',
  initialState: {
    loading: false,
    error: null,
    success: false,
    data: null,
    historyData: [],
    managerList: [],
    updateManagerdata:null
  },
  reducers: {
    resetStatus: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addManager.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addManager.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(addManager.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(deactivateManager.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deactivateManager.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(deactivateManager.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getHistoryData.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getHistoryData.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.historyData = action.payload;
      })
      .addCase(getHistoryData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getManagerList.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getManagerList.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.managerList = action.payload;
      })
      .addCase(getManagerList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(updateManager.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateManager.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updateManagerdata = action.payload;
      })
      .addCase(updateManager.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetStatus } = managerSlice.actions;

export default managerSlice.reducer;
